<template>
  <base-modal-card>
    <div class="flex-1 p-5">
      <p>{{body}}</p>
    </div>
    <div class="p-5">
      <v-button v-if="retryButton" class="mr-5 bg-transmaes-green" @click="retry" :label="$t('error_retryButton')"/>
      <v-button v-if="closeButton" class="bg-transmaes-red" @click="close" :label="$t('error_cancelButton')"/>
    </div>
  </base-modal-card>
</template>

<script>
  import VButton from '../common/VButton';
  import BaseModalCard from '../base/BaseModalCard';

  export default {
    name: 'ErrorModalCard',
    components: {
      BaseModalCard,
      VButton,
    },
    props: {
      title: String,
      body: String,
      retryButton: Boolean,
      closeButton: Boolean,
    },
    methods: {
      retry() {
        this.$emit('retry');
      },
      close() {
        this.$emit('close');
      },
    },
  };
</script>

<style lang="scss" scoped>
  p{
    white-space: pre-line
  }
</style>
